<template>
  <div
    class="timesheet-filters"
    :class="{
      'server-error': serverError,
    }"
  >
    <div class="timesheet-filters__row">
      <div class="timesheet-filters__filters">
        <div class="timesheet-filters__controls">
          <month-select
            v-model="filters.period"
            class="timesheet-filters__period timesheet-filters__item"
            label="Период"
            :invalid="serverError"
          ></month-select>
          <c-input2
            v-model="filters.filial"
            class="timesheet-filters__filial timesheet-filters__item"
            type="select"
            label="Филиал"
            :searchable="true"
            :items="collections.filials"
            :required="filialError || serverError"
            :required-condition="filialError || !!serverError"
          ></c-input2>
        </div>
        <error-feedback
          v-if="serverError"
          :text="serverError"
          class="timesheet-filters__error timesheet-filters__item"
        ></error-feedback>
      </div>

      <div class="timesheet-filters__actions timesheet-filters__item">
        <c-button2 class="timesheet-filters__reset" label="Сбросить" size="large" @click="$emit('reset')"></c-button2>
        <c-button2
          class="timesheet-filters__apply"
          label="Применить"
          :disabled="!filters.filial || serverError"
          color="primary"
          size="large"
          @click="$emit('apply')"
        ></c-button2>
      </div>
    </div>
  </div>
</template>

<script>
import CButton2 from "@/components/controls2/Button";
import ErrorFeedback from "@/components/error-feedback";
import CInput2 from "@/components/controls2/Input";
import MonthSelect from "@/components/month-select";

export default {
  components: { CButton2, ErrorFeedback, CInput2, MonthSelect },

  props: ["serverError", "filters", "submitted"],

  data() {
    return {
      collections: {
        filials: [],
      },
    };
  },

  computed: {
    filialError() {
      if (!this.submitted) return false;
      return this.filters.filial ? false : "Обязательное поле";
    },
  },

  created() {
    this.$store.dispatch("timesheets/loadAllFilials").then((items) => {
      this.collections.filials = items;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.timesheet-filters {
  &__row {
    display: flex;
    margin-left: -15px;
    margin-right: -15px;
  }
  &__controls {
    display: flex;
  }

  &__item {
    padding-left: 15px;
    padding-right: 15px;
  }
  &.server-error {
    & /deep/ {
      .c-input-required {
        display: none;
      }
    }
  }
  &__filial {
    width: 297px;
  }
  &__actions {
    display: flex;
    padding-top: 15px;
  }
  &__reset {
    margin-right: 10px;
  }
}
@include onlyMobile {
  .timesheet-filters {
    &__actions {
      margin-left: -5px;
      margin-right: -5px;
    }

    &__reset,
    &__apply {
      width: calc(50% - 10px);
      margin-left: 5px;
      margin-right: 5px;
    }
  }
}
</style>
